<p-confirmDialog></p-confirmDialog>
<!-- Connector Dialog -->
<p-dialog
  [(visible)]="showConnectorDialog"
  [modal]="true"
  [closable]="false"
  [header]="connectorDialogTitle"
  [style]="{ width: '80%', height: '80%' }"
>
  <div class="field">
    <label for="name">Connector Name</label>
    <input
      id="name"
      type="text"
      pInputText
      [(ngModel)]="newConnector.name"
      required
      autofocus
      class="w-full"
    />
  </div>

  <div class="field">
    <label for="type">Connector Type</label>
    <p-select
      inputId="type"
      [options]="connectorTypes"
      [(ngModel)]="newConnector.type"
      placeholder="Select a Connector Type"
      [disabled]="isEditMode()"
      class="w-full"
    ></p-select>
  </div>

  <!-- ▽  Mongo credentials, shown when Type = Mongo ▽ -->
  <div *ngIf="newConnector.type === 'Mongo'">
    <div class="field">
      <label for="mongoUri">Mongo URI</label>
      <input
        pInputText
        class="w-full"
        id="mongoUri"
        [(ngModel)]="newConnector.credentials.mongoUri"
        required
      />
    </div>

    <div class="field">
      <label for="mongoDb">Database (optional)</label>
      <input
        pInputText
        class="w-full"
        id="mongoDb"
        [(ngModel)]="newConnector.credentials.mongoDb"
      />
    </div>

    <div class="field">
      <label for="mongoUser">Username (optional)</label>
      <input
        pInputText
        class="w-full"
        id="mongoUser"
        [(ngModel)]="newConnector.credentials.mongoUser"
      />
    </div>

    <div class="field">
      <label for="mongoPass">Password (optional)</label>
      <input
        pInputText
        class="w-full"
        id="mongoPass"
        type="password"
        [(ngModel)]="newConnector.credentials.mongoPass"
      />
    </div>
  </div>

  <!-- LoanPro Credentials -->
  <div *ngIf="newConnector.type === 'LoanPro'">
    <div class="field">
      <label for="autopalId">Autopal ID</label>
      <input
        id="autopalId"
        class="w-full"
        type="text"
        pInputText
        [(ngModel)]="newConnector.credentials.autopalId"
        required
      />
    </div>
    <div class="field">
      <label for="apiUrl">API URL</label>
      <input
        id="apiUrl"
        type="text"
        pInputText
        class="w-full"
        [(ngModel)]="newConnector.credentials.apiUrl"
        required
      />
    </div>
    <div class="field">
      <label for="apiToken">API Token</label>
      <input
        id="apiToken"
        type="text"
        class="w-full"
        pInputText
        [(ngModel)]="newConnector.credentials.apiToken"
        required
      />
    </div>
  </div>

  <div class="flex gap-2 mt-4 justify-content-end">
    <p-button
      label="Cancel"
      icon="pi pi-times"
      (click)="showConnectorDialog = false"
    ></p-button>
    <p-button
      label="Save"
      icon="pi pi-check"
      (click)="saveConnector()"
      [disabled]="!newConnector.name || !newConnector.type"
    ></p-button>
  </div>
</p-dialog>

<!-- Connector List -->
<p-table [value]="connectors">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Type</th>
      <th>Default</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-connector>
    <tr>
      <td>{{ connector.name }}</td>
      <td>{{ connector.type }}</td>
      <td>
        <p-toggleswitch
          [ngModel]="connector.isDefault"
          (ngModelChange)="onDefaultToggle($event, connector)"
        ></p-toggleswitch>
      </td>
      <td>
        <!-- Edit Button -->
        <button
          pButton
          icon="pi pi-pencil"
          class="p-button-text p-mr-2"
          (click)="editConnector(connector)"
          pTooltip="Edit Connector"
        ></button>

        <!-- Delete Button -->
        <button
          pButton
          icon="pi pi-trash"
          class="p-button-danger p-button-text p-mr-2"
          (click)="deleteConnector(connector)"
          pTooltip="Delete Connector"
        ></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="flex gap-2 mt-4 justify-content-end">
  <!-- Export Button -->
  <button
    pButton
    severity="secondary"
    label="Export Connectors"
    icon="pi pi-download"
    (click)="exportConnectors()"
  ></button>

  <!-- Import Button -->
  <!-- We hide the file input and trigger it with this button -->
  <button
    pButton
    severity="secondary"
    label="Import Connectors"
    icon="pi pi-upload"
    (click)="fileInput.click()"
  ></button>
  <input
    #fileInput
    type="file"
    accept=".json"
    style="display: none"
    (change)="importConnectors($event)"
  />
  <button
    pButton
    label="Add Connector"
    icon="pi pi-plus"
    (click)="openNewConnectorDialog()"
  ></button>
</div>
